"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Info = exports.StyledCard = undefined;

var _templateObject = _taggedTemplateLiteral(["\n  max-width: ", ";\n  width: 100%;\n  color: ", ";\n  font-size: ", ";\n  text-transform: ", ";\n  padding-top: 100%;\n\n  img {\n    position: absolute;\n    z-index: 10;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    margin: auto;\n    width: auto;\n    max-width: 100%;\n    max-height: 100%;\n  }\n\n  &:hover {\n    color: ", ";\n  }\n  background: ", ";\n  border: ", ";\n  color: ", ";\n"], ["\n  max-width: ", ";\n  width: 100%;\n  color: ", ";\n  font-size: ", ";\n  text-transform: ", ";\n  padding-top: 100%;\n\n  img {\n    position: absolute;\n    z-index: 10;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    margin: auto;\n    width: auto;\n    max-width: 100%;\n    max-height: 100%;\n  }\n\n  &:hover {\n    color: ", ";\n  }\n  background: ", ";\n  border: ", ";\n  color: ", ";\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n  font-size: 16px;\n  .product-title {\n    color: #212529;\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n  .price {\n    color: #8c8c8c;\n  }\n"], ["\n  font-size: 16px;\n  .product-title {\n    color: #212529;\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n  .price {\n    color: #8c8c8c;\n  }\n"]);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _globalCss = require("../../../styles/globalCss");

var variable = _interopRequireWildcard(_globalCss);

var _colors = require("../../../styles/colors");

var colors = _interopRequireWildcard(_colors);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledCard = exports.StyledCard = _styledComponents2.default.a(_templateObject, function (props) {
  return props.maxWidth;
}, function (props) {
  return props.color || colors.blackColor;
}, function (props) {
  return props.fontSize || variable.baseFont;
}, function (props) {
  return props.textTransform;
}, function (props) {
  return props.hoverColor || colors.redColor;
}, function (props) {
  return props.background;
}, function (props) {
  return props.border;
}, function (props) {
  return props.color;
});
var Info = exports.Info = _styledComponents2.default.span(_templateObject2);